/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto,
} from '../../services/wealthlane-customer-services';
import {
  EarlyExerciseConfigurationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto,
} from '../../services/wealthlane-award-settlement-services';

const useGetEarlyExerciseConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  planTypeCategoryId: string
): UseQueryResult<
  | Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto
  | undefined,
  unknown
> => {
  const earlyExerciseConfig = useQuery(['getEarlyExerciseConfig'], async () => {
    return await handleRequest(
      EarlyExerciseConfigurationService.getApiAwardSettlementApiAppEarlyExerciseConfigurationEarlyExerciseConfiguration(
        planTypeCategoryId
      )
    );
  });
  return earlyExerciseConfig;
};

export default useGetEarlyExerciseConfig;
